(function () {
  function qs(sel) { return document.querySelector(sel); }

  function openSearch() {
    const modal = qs('[data-cin-search-modal]');
    const btn = qs('[data-cin-search-open]');
    if (!modal) return;

    modal.hidden = false;
    if (btn) btn.setAttribute('aria-expanded', 'true');

    const input = modal.querySelector('.cin-search-modal__input');
    if (input) setTimeout(() => input.focus(), 50);
  }

  function closeSearch() {
    const modal = qs('[data-cin-search-modal]');
    const btn = qs('[data-cin-search-open]');
    if (!modal) return;

    modal.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-cin-search-open]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      openSearch();
      return;
    }

    const closeBtn = e.target.closest('[data-cin-search-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      closeSearch();
      return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  // Debug marker (remove later if you want)
  console.log('[cin-search] loaded');
})();
